import { Component } from '@angular/core';

import { CarrierReportService, RegistryReportData } from 'src/app/services/carrier-report.service';
import { ScrBaseComponent } from '../../base.component';

class TransferReportRequest {
  startDate!: Date;
  endDate!: Date;
}

@Component({
  templateUrl: './registry-reports.component.html',
  styleUrls: ['./registry-reports.component.scss']
})
export class RegistryReportsComponent extends ScrBaseComponent {

  public dateChoice = 'All';
  public dateChoices = [
    { label: 'All', value: 'All' },
    { label: 'Current Month', value: 'CurrentMonth' },
    { label: 'Previous Month', value: 'PreviousMonth' },
    { label: 'Year-to-Date', value: 'YearToDate' },
    { label: 'Date Range', value: 'DateRange' }
  ];
  public agedReportDateChoice = 'YearToDate';
  public agedReportDateChoices = [
    { label: 'Year-to-Date', value: 'YearToDate' },
    { label: 'Since Last Week', value: 'SinceLastWeek' },
    { label: 'Since Last Month', value: 'SinceLastMonth' },
    { label: 'Since Last Year', value: 'SinceLastYear' }
  ];
  public today = new Date();
  public registryReportData: RegistryReportData = new RegistryReportData();
  public transferReportRequest: TransferReportRequest = {} as TransferReportRequest;

  constructor(private carrierReportService: CarrierReportService) {
    super();
    this.observe(this.carrierReportService.getReports(), rsp => {
      this.registryReportData = rsp.data;
      return false;
    });
  }

  onChangeSelection() {
    if (this.dateChoice === 'DateRange') {
      this.transferReportRequest = { startDate: this.today, endDate: this.today } as TransferReportRequest;
    } else {
      this.transferReportRequest = {} as TransferReportRequest;
    }
  }

  clearEndDate() {
    const { startDate } = this.transferReportRequest;
    this.transferReportRequest = { startDate } as TransferReportRequest;
  }

  downloadReport(downloadLink: string | undefined) {
    window.open(downloadLink);
  }

  getAgedReport() {
    this.clearErrors();
    this.transferReportRequest = {} as TransferReportRequest;
    this.observeDownloadOrAny(this.carrierReportService.getAgedReports(this.agedReportDateChoice), rsp => {
      if (!this.carrierReportService.processBlobResponseDownload(rsp)) {
        this.displayLocalizedError('Unable to download requested report.', undefined, 'message');
      }
    });
  }

  dateRangeTransfer() {
    this.clearErrors();
    if (this.dateChoice === 'DateRange') {
      const { startDate: start, endDate: end } = this.transferReportRequest;
      if (start && end) {
        const stringStart = this.formatDate(start);
        const stringEnd = this.formatDate(end);
        this.observeDownloadOrAny(this.carrierReportService.getTransferReportDateRange(this.dateChoice, stringStart, stringEnd), rsp => {
          if (!this.carrierReportService.processBlobResponseDownload(rsp)) {
            this.displayLocalizedError('Unable to download requested report.', undefined, 'message');
          }
        });
      } else if (start && !end) {
        this.displayLocalizedError('scr.endDateRequired', undefined, 'message');
        this.jumpToTop();
      } else {
        this.displayLocalizedError('scr.rangerequired', undefined, 'message');
        this.jumpToTop();
      }
    } else {
      this.transferReportRequest = {} as TransferReportRequest;
      this.observeDownloadOrAny(this.carrierReportService.getTransferReportDateRange(this.dateChoice), rsp => {
        if (!this.carrierReportService.processBlobResponseDownload(rsp)) {
          this.displayLocalizedError('No data found for selected criteria.');
          this.jumpToTop();
        }
      });
    }
  }

  formatDate(date: Date) {

    const d = new Date(date);
    const year = d.getFullYear();
    let
      month = String(d.getMonth() + 1),
      day = String(d.getDate());

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

}
